module.exports = __webpack_public_path__ + "static/img/core.70c7af4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/core.png
// module id = 6Sy0
// module chunks = 0